// parse integer values from typoscript settings
if(IgTemplateSettings !== undefined) {
    for (let property in IgTemplateSettings) {
        if (IgTemplateSettings.hasOwnProperty(property)) {
            let value = IgTemplateSettings[property];
            if (!isNaN(value)) {
                IgTemplateSettings[property] = parseInt(value);
            }
        }
    }
}

/**
 * Global Settings Object
 * merged with settings from typoscript
 * @type object
 */
export const Settings = Object.assign({
    classScrolled: 'scrolled',
    classTransitionEnabled: 'transitionEnabled',
    classPositionMenuLeft: 'positionLeft',
    headerScrolledAt: 24,
    headerScrollToggleMinWidth: 640,
    bannerAdjust: 1,
    fixedHorizontalSubMenu: 1,
    backToTopButtonAt: 300,
    backToTopButtonAnimationDuration: 400,
    backToTopButtonMinWidth: 640,
	sliderId: '#t3s-headerslider'
}, IgTemplateSettings);

export const PluginNames = {};